import { f as toQueryString, n as getCurrentPath, o as getSafeNextQueryParam } from "./utils-CT_1OHHh.js";
import { Redirect, useLocation } from "react-router-dom";
import { jsx } from "react/jsx-runtime";
//#region src/Navigation/External/NavigateUtils.ts
/**
* Navigates to a url with a hard refresh.
* Do not use this for React routes. Consider adding your route to `ANGULAR_EXACT_PATH_MATCHES`
* and manage all path changes via `react-router` path changes.
* `ANGULAR_EXACT_PATH_MATCHES` will automatically reload the page when visiting Angular paths
* and as you convert to React, you can simply remove your path from that, reducing other refactoring.
*
* @param url - The url to navigate to.
*/
function navigateAndRefreshBrowser(url) {
	window.location.assign(url);
}
/**
* Open url in a new tab, while protecting from security risks related to `referrer`
*
* See https://getcolor.atlassian.net/browse/ENG-584
* https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
* https://mathiasbynens.github.io/rel-noopener
* See lint rule react/jsx-no-target-blank
*/
function openNewBrowserTab(url) {
	window.open(url, "_blank", "noopener,noreferrer");
}
/**
* Scroll an element into view. Accounts for legacy browsers that do not support
* `scrollIntoView`.
*
* @param element The element to scroll into view.
* @param options The options to pass to `scrollIntoView` if it is called.
*/
function scrollIntoView(element, options) {
	const doesScrollIntoViewExist = Boolean(element.scrollIntoView);
	/**
	* Some legacy browsers do not support `scrollIntoView`.
	* Base `focus` options on browser support.
	*/
	element.focus?.({ preventScroll: doesScrollIntoViewExist });
	if (doesScrollIntoViewExist) element.scrollIntoView(options);
}
//#endregion
//#region src/Navigation/RedirectWithNextParam/RedirectWithNextParam.tsx
/**
* Redirects a user while preserving the `next` param (or placing the current path in the `next` param)
*
* Most commonly used with authentication (ie: if a user isn't signed in and attempts to navigate to a
* path that requires authentication, we'll redirect them to a sign in page and place the path they originally
* navigated to in the `next` param).
*/
var RedirectWithNextParam = (props) => {
	const { redirectPath } = props;
	const { search } = useLocation();
	return /* @__PURE__ */ jsx(Redirect, { to: {
		pathname: redirectPath,
		search: toQueryString({ next: getSafeNextQueryParam(search) ?? getCurrentPath() })
	} });
};
//#endregion
export { scrollIntoView as i, navigateAndRefreshBrowser as n, openNewBrowserTab as r, RedirectWithNextParam as t };

//# sourceMappingURL=Navigation-Cy8aGXzV.js.map